import React, { useEffect, useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { AnswerItem, QuestionValidationTypes, ReduxState } from 'interface';
import { QuestionSLPRef, SLPQuestionType } from '../../questions.index';
import SLPDatePicker, { SLPDatePickerRef } from 'utilities/slp/datePicker/datePicker.index';
import { extractTitle } from 'scripts/string';
import { createQuestionTitle } from '../questionsTypes.script';

const SLPDateQuestion: React.ForwardRefRenderFunction<
    QuestionSLPRef,
    ConnectedProps<typeof connector> & SLPQuestionType
> = (props: ConnectedProps<typeof connector> & SLPQuestionType, ref) => {
    React.useImperativeHandle(ref, () => ({
        validate: (e?: boolean) => validate(e),
        submit: (e?: boolean) => onSubmit(e),
    }));
    const lang = props.lang.SLP.questionsTypes;
    const question = props.question;
    const inputRef = useRef<SLPDatePickerRef>(null);
    const [title, setTitle] = useState(question.title);
    const index = props.answerList?.findIndex((i) => i.question.id === question.id);
    let isJalali = true;
    if (question.validations) {
        const a = question.validations.find((i) => i.title === QuestionValidationTypes.dateBase)?.value;
        if (Number(a) !== 1) isJalali = false;
    }

    const [hint, setHint] = useState(question.description);

    useEffect(() => {
        if (question.description)
            setHint(
                createQuestionTitle(
                    question.description,
                    props.answerList,
                    props.answer?.answerer_info,
                    props.form.indicators,
                ),
            );
        setTitle(
            createQuestionTitle(question.title, props.answerList, props.answer?.answerer_info, props.form.indicators),
        );
    }, [props.answerList]);

    function getValue(a: any) {
        if (question.validations) {
            const b = question.validations.find((i) => i.title === a);
            if (b && b.value) return new Date(b.value.toString());
        }
    }

    function validate(e?: boolean) {
        if (question.is_required && !inputRef.current?.getValue()) {
            if (e) inputRef.current?.setError(lang.dateEmp);
            return false;
        }
        return true;
    }

    function setAnswerItem() {
        const value = inputRef.current?.getValue();
        const data = [...props.answerList];
        if (value && validate()) {
            const response: AnswerItem = {
                value: value.toISOString(),
                question: props.question,
                id: question.id,
                answer: props.answer?.id,
            };
            if (index !== undefined && index > -1) data[index] = response;
            else data?.push(response);
            props.setAnswerList(data);
        } else if (index !== undefined && index > -1) data.splice(index, 1);
    }

    function onSubmit(e?: boolean) {
        const value = inputRef.current?.getValue();
        if (value && validate(e) && props.answer)
            props.submit({
                value: value.toISOString(),
                question: question,
                id: new Date().getTime(),
                created_at: new Date().toISOString(),
            });
    }

    let defaultValue: Date | undefined = undefined;
    if (index !== undefined && index > -1) {
        const value = props.answerList[index].value;
        if (value !== undefined) defaultValue = new Date(value);
    }

    return (
        <SLPDatePicker
            minDate={getValue(QuestionValidationTypes.startDate)}
            maxDate={getValue(QuestionValidationTypes.endDate)}
            hint={extractTitle(hint, false, false)}
            ref={inputRef}
            counter={props.counter}
            label={extractTitle(title, false, false)}
            image={question.image_file}
            isJalali={isJalali}
            color={props.form?.answer_color}
            labelColor={props.form?.question_color}
            required={question.is_required}
            dir={props.form.direction}
            defaultValue={defaultValue}
            onChange={setAnswerItem}
        />
    );
};
const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPDateQuestion));
